import { inject } from 'mobx-react';
import { useHistory } from 'react-router';
import * as React from 'react';

import { CompareSelectionAdaptEx } from '@shared-ui/retail-lodging-compare';
import { getPropertySearchCriteriaFromQueryParams } from '@shared-ui/search-tools-lodging';

import { mapMultiItemContextInput } from 'src/common/stores/adapters';
import { MultiItemStore } from 'src/common/stores/multi-item-store';

interface PropertyCompareWrapperProps {
  multiItem?: MultiItemStore;
}

export const PropertyCompareWrapper: React.FC<PropertyCompareWrapperProps> = inject('multiItem')(
  ({ multiItem: { multiItemContext } = {} }) => {
    const { search } = useHistory().location;
    const { propertySearchCriteriaInput } = React.useMemo(
      () => getPropertySearchCriteriaFromQueryParams(new URLSearchParams(search)),
      [search]
    );
    const inputs = {
      criteria: propertySearchCriteriaInput,
      shoppingContext:
        multiItemContext?.id && multiItemContext?.packageType ? { multiItem: mapMultiItemContextInput(multiItemContext) } : null,
    };

    return <CompareSelectionAdaptEx inputs={inputs} skipSsr />;
  }
);

PropertyCompareWrapper.displayName = 'PropertyCompareWrapper';
